import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDeliveryDuration(
  minDuration?: number | null,
  maxDuration?: number | null,
): string {
  // Default fallback if no duration information is available
  if (!minDuration && !maxDuration) {
    return "3-5 Werktage";
  }

  // If only one value is available, use it as both min and max
  const min = minDuration ?? maxDuration ?? 3;
  const max = maxDuration ?? minDuration ?? 5;

  // Handle edge cases
  if (min === max) {
    return min === 1 ? "1 Werktag" : `${min} Werktage`;
  }

  // Return range
  return `${min}-${max} Werktage`;
}
